import React, { useState } from "react";
import { Configure } from "react-instantsearch";

const AlphabetFilter = () => {
  const [activeLetter, setActiveLetter] = useState("");
  const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  return (
    <div className="flex items-center justify-between px-6 md:px-6 text-13 text-pl-text-secondary font-normal dark:font-light max-w-[800px] w-full">
      <Configure
        hitsPerPage={10}
        filters={activeLetter ? `starting_letter:${activeLetter}` : ""}
      />
      {alphabet.map((alphabet) => (
        <div
          key={alphabet}
          className={`whitespace-nowrap py-1 px-0 flex items-center justify-center text-13 font-normal ${
            activeLetter === alphabet
              ? "font-semibold border-b-2 border-pl-text-primary text-pl-accent "
              : "text-pl-text-primary"
          }`}
          onClick={() => {
            setActiveLetter(alphabet);
          }}
          aria-label={`Filter by letter ${alphabet}`}
          aria-pressed={activeLetter === alphabet}
          style={{ cursor: "pointer" }}
        >
          {alphabet}
        </div>
      ))}
      <button
        className={`whitespace-nowrap py-1 px-0 flex items-center justify-center text-13 font-normal ${
          activeLetter === ""
            ? " text-pl-accent font-semibold border-pl-text-primary"
            : "text-pl-text-primary"
        }`}
        onClick={() => setActiveLetter("")}
      >
        All
      </button>
    </div>
  );
};
export default AlphabetFilter;
